<template>
  <v-dialog :model-value="isDialogActived" max-width="1180px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">
        <span>{{ getDialogTitle() }}</span>
      </v-card-title>
      <div class="d-flex flex-wrap ga-2 px-6 pb-3">
        <quick-create-catalog kind="company" label="Agregar empresa" :active="isDialogActived" />
        <quick-create-catalog kind="location" label="Agregar lugar" location-type="DESTINO" :active="isDialogActived"
          @saved="editedItem.destiny = $event" />
      </div>

      <v-card-text>
        <v-form ref="form" v-model="valid" validate-on="lazy">
          <section class="form-section">
            <h2>Datos de salida</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Nro. de Salida"
                  v-model="editedItem.outcomeNumber"
                  type="number"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Fecha de Carga"
                  v-model="editedItem.loadingDate"
                  type="date"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  label="Destino"
                  v-model="editedItem.destiny"
                  item-title="name"
                  return-object
                  :items="destinationLocations"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Carta de porte</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Carta de Porte Nro."
                  v-model="editedItem.waybill"
                  :rules="[rules.lenght12]"
                  maxlength="12"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="C.T.G. Nro." v-model="editedItem.ctg" type="number" v-bind="fieldProps" />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  label="Titular de Carta de Porte"
                  v-model="editedItem.waybillOwner"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  label="Remitente Comercial"
                  v-model="editedItem.commercialSender"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  label="Destinatario"
                  v-model="editedItem.receiver"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Transporte y peso</h2>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  label="Transportista"
                  v-model="editedItem.carrier"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Chofer" v-model="editedItem.driverName" v-bind="fieldProps" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Patente de Camion"
                  v-model="editedItem.truckPatent"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Patente de Acoplado"
                  v-model="editedItem.trailerPatent"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Distancia a recorrer"
                  suffix="Km."
                  v-model="editedItem.distanceToTravel"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Bruto"
                  suffix="Kg."
                  v-model="editedItem.grossWeight"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Tara"
                  suffix="Kg."
                  v-model="editedItem.truckWeight"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Neto" suffix="Kg." :model-value="netWeight" readonly v-bind="fieldProps" />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Mercaderia a despachar</h2>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  label="Tipo de Empaque"
                  v-model="editedItem.packagingType"
                  item-title="packagingType"
                  return-object
                  :items="getPackagingTypes"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Cantidad de Bultos"
                  v-model="editedItem.bagQuantity"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12">
                <commodity-selector v-if="!(editedItem.id > 0)"></commodity-selector>
              </v-col>
              <v-col cols="12">
                <commodity-detail-to-dispatch :readonly="editedItem.id > 0"></commodity-detail-to-dispatch>
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <v-textarea label="Observaciones" v-model="editedItem.obs" auto-grow rows="3" v-bind="fieldProps" />
          </section>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" @click="close">Cancelar</v-btn>
        <v-btn v-if="canSave" color="primary" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import CommodityListSelector from '../Commodity/CommodityListSelector'
import CommodityDetailToDispatch from '../Commodity/CommodityDetailToDispatch'
import { LOCATION_TYPES, locationsForType } from '@/services/location/LocationTypeUtils'
import QuickCreateCatalog from '../Common/QuickCreateCatalog.vue'

export default {
  name: 'AddEditOutcomeForm',
  components: {
    QuickCreateCatalog,
    'commodity-selector': CommodityListSelector,
    'commodity-detail-to-dispatch': CommodityDetailToDispatch
  },

  data: () => ({
    valid: true,
    fieldProps: {
      variant: 'outlined',
      density: 'comfortable'
    },
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0',
      lenght12: v => ((!v) || (String(v).length === 12)) || 'El numero de Carta de Porte debe poseer 12 digitos.'
    },
    editedItem: {
      id: -1,
      outcomeNumber: '',
      analysisId: null,
      commodityStock: [],
      imgPath: '',
      waybill: '',
      ctg: '',
      loadingDate: '',
      waybillOwner: '',
      commercialSender: '',
      deliveryRepresentative: '',
      receiver: '',
      grossWeight: 0,
      truckWeight: 0,
      obs: '',
      destiny: '',
      carrier: '',
      driverName: '',
      truckPatent: '',
      trailerPatent: '',
      distanceToTravel: 0,
      packagingType: '',
      bagQuantity: 1
    },
    isCommoditySelected: false
  }),

  computed: {
    ...mapGetters('outcomeModule', ['isDialogActived']),
    ...mapGetters('locationModule', ['getBaseLocations']),
    ...mapGetters('companyModule', ['getBaseCompanies']),
    ...mapGetters('commodityModule', ['getSelectedItems']),
    ...mapGetters('typesModule', ['getPackagingTypes', 'getGrainTypes']),
    ...mapGetters('authModule', ['hasPermission']),
    canSave () { return this.hasPermission(this.editedItem.id > 0 ? 'plant.outcomes.update' : 'plant.outcomes.create') },
    destinationLocations () {
      return locationsForType(this.getBaseLocations, LOCATION_TYPES.DESTINATION, this.editedItem.destiny?.id)
    },
    netWeight () {
      return Number(this.editedItem.grossWeight || 0) - Number(this.editedItem.truckWeight || 0)
    }
  },

  created () {
    this.$store.dispatch('locationModule/getBaseLocations')
    this.$store.dispatch('companyModule/getBaseCompanies')
    this.$store.dispatch('typesModule/getPackagingTypes')
  },

  watch: {
    'isDialogActived': function (val) {
      if (val) {
        this.editedItem = Object.assign({}, this.$store.getters['outcomeModule/getSelectedItem'])
        if (this.editedItem.id > 0) this.loadRetiredCommodities()
      } else {
        this.editedItem.commodityStock = this.$store.getters['commodityModule/getDefaultItem']
      }
    },
    'getSelectedItems': function (value) {
      if (value && value.length > 0) {
        this.editedItem.commodityStock = this.$store.getters['commodityModule/getSelectedItems']
        this.isCommoditySelected = this.editedItem.commodityStock.length > 0
      }
    }
  },

  methods: {
    getDialogTitle () {
      let dialogTitle
      if (this.editedItem.id > 0) {
        dialogTitle = `Editando Salida: ${this.editedItem.outcomeNumber}`
      } else {
        dialogTitle = 'Agregar Salida'
      }
      return dialogTitle
    },

    close () {
      this.editedItem = Object.assign({}, this.$store.getters['outcomeModule/getDefaultItem'])
      this.editedItem.commodityStock = Object.assign([], [])
      this.valid = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.cancelSelCommodity()
      this.$store.commit('outcomeModule/setSelectedItemAsDefault')
      this.$store.dispatch('outcomeModule/setDialogActived', false)
    },

    cancelSelCommodity () {
      this.isCommoditySelected = false
      this.$store.commit('commodityModule/setSelectedItemAsDefault')
    },

    loadRetiredCommodities () {
      const commodities = Array.isArray(this.editedItem.commodities)
        ? this.editedItem.commodities
        : Object.values(this.editedItem.commodities || {})
      const selected = commodities.map(item => ({
        ...item,
        stock: item.amount,
        bagQtyStock: item.bagQuantity
      }))
      this.$store.dispatch('commodityModule/setSelectedItems', selected)
      this.isCommoditySelected = selected.length > 0
    },

    async save () {
      if (!this.canSave) return
      const isEdit = this.editedItem.id > 0
      let commoditiesSelected = this.$store.getters['commodityModule/getSelectedItems']
      const validation = await this.$refs.form.validate()
      if (validation.valid && (isEdit || this.isCommodityToWithdrawOK(commoditiesSelected))) {
        try {
          this.editedItem.commodityStock = isEdit ? [] : commoditiesSelected
          await this.$store.dispatch('outcomeModule/saveOutcome', this.editedItem)
          this.close()
        } catch (e) {
          console.log('Error saving outcome.', e)
        }
      }
    },

    isCommodityToWithdrawOK (commoditiesSelected) {
      let isOK = false
      if (commoditiesSelected && commoditiesSelected.length > 0 &&
        (this.sumAmountOfCommoditiesTowithdraw(commoditiesSelected) <= this.netWeight)) {
        isOK = true
      } else {
        let errorMsg = 'Controle que selecciono correctamente la mercaderia a retirar. El stock existente debe ser igual o mayor al que desea retirar.'
        let data = { infoDialog: true, title: 'ERROR', content: errorMsg, closeBtnLabel: 'Entendido' }
        this.$store.dispatch('alertDialogModule/setData', data)
      }
      return isOK
    },

    sumAmountOfCommoditiesTowithdraw (commoditiesSelected) {
      return commoditiesSelected.reduce((total, item) => total + Number(item.amount || 0), 0)
    }
  }
}
</script>
